module.exports = __webpack_public_path__ + "static/media/trash-white.f25883d9.svg";